import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CreatePhaseInput, Phase, UpdatePhaseInput, WorkflowPort } from '../domain/workflow'

const createPhase = async (
	port: WorkflowPort,
	input: CreatePhaseInput,
	notify: NotifyPort,
): Promise<Phase | null> => {
	try {
		const phase = await port.createPhase(input)
		const inboxStep = await port.createStep({
			teamWorkflowId: phase.teamWorkflow.id,
			name: 'Inbox',
			description: null,
			isInbox: true,
		})
		await port.createTransition({
			fromStepId: inboxStep.id,
			label: 'Atribuir',
			trigger: 'manual',
			target: { kind: 'none' },
			isDefault: false,
		})
		notify.success('workflow.phaseCreated')
		return phase
	} catch {
		notify.error('workflow.phaseCreateFailed')
		return null
	}
}

const updatePhase = async (
	port: WorkflowPort,
	input: UpdatePhaseInput,
	notify: NotifyPort,
): Promise<Phase | null> => {
	try {
		const phase = await port.updatePhase(input)
		notify.success('workflow.phaseUpdated')
		return phase
	} catch {
		notify.error('workflow.phaseUpdateFailed')
		return null
	}
}

const deletePhase = async (
	port: WorkflowPort,
	id: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.deletePhase(id)
		notify.success('workflow.phaseDeleted')
		return true
	} catch {
		notify.error('workflow.phaseDeleteFailed')
		return false
	}
}

export { createPhase, updatePhase, deletePhase }
